import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaRobot } from "react-icons/fa";

export default function AIAgentNode({ data, selected }) {
  const kbCount = Array.isArray(data.knowledgeBaseIds) ? data.knowledgeBaseIds.length : 0;
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[190px] transition-shadow ${
        selected ? "border-fuchsia-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-fuchsia-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-gradient-to-r from-fuchsia-600 to-violet-500">
        <FaRobot size={11} className="text-white" />
        <span className="text-xs font-semibold text-white">AI Agent</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5 space-y-1.5">
        {data.prompt ? (
          <p className="text-xs text-ink-muted line-clamp-2">{data.prompt}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to train your AI agent</p>
        )}
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-fuchsia-100 text-fuchsia-700 text-2xs font-medium">
            Fully AI-led
          </span>
          {kbCount > 0 && (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-violet-100 text-violet-700 text-2xs font-medium">
              {kbCount} knowledge
            </span>
          )}
          {data.pauseOnHumanReply !== false && (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-amber-100 text-amber-700 text-2xs font-medium">
              Human takeover
            </span>
          )}
          {data.maxTurns != null && (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-slate-100 text-slate-700 text-2xs font-medium">
              {data.maxTurns === 0 ? "Unlimited" : `${data.maxTurns} turns`}
            </span>
          )}
        </div>
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-fuchsia-500 !border-2 !border-white"
      />
    </div>
  );
}
